import { AlpineComponent } from '@alpinejs/csp';

const HeroTeaser = (): AlpineComponent => ({
  visible: false,
  handleIntersect() {
    this.visible = true;
  },
  getClassName() {
    return this.visible ? 'hero-teaser--visible' : '';
  }
});

export default HeroTeaser;
